<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script>
import { config } from '@/plugins/env.config'
export default {
  name: 'App',
  beforeCreate(){
    const favicon = document.getElementById("favicon")
    if(config.theme === 'KONEKSI'){
      favicon.href = process.env.BASE_URL+"koneksi-favicon.ico"
    }
    else{
      favicon.href = process.env.BASE_URL+"favicon.ico"
    }
  }
};
</script>
